import { Textarea ,TextareaProps } from "@fluentui/react-components";


export const InputCustom = (props: Partial<TextareaProps>) => (
  
    <Textarea {...props} 
      style={{ 
      zIndex:"1", 
      marginBottom:"5px"  
    }}     
    rows={2}/>
  
);
